import { createMessengerInfo, setObject } from '../../utils/useful';
import { APPEND_MESSAGES, MESSAGE_SEEN, APPEND_ONE_MESSAGE, CHANGE_LAST_SEEN, ADD_MESSENGERS, CHANGE_TEMP_MESSAGE, CHANGE_MESSAGE, ADD_MESSAGES, ADD_NOTIFICATION, REDUCE_NOTIFICATION, SET_NOTIFICATION_COUNT, UPDATE_MESSENGERS, UPDATE_ACTIONS, UPDATE_MESSAGES, REMOVE_MESSAGES, REMOVE_MESSENGER, UPDATE_MESSENGER, CHANGE_ONE_LAST_SEEN } from '../actionsList';



const initialInfo = {
    messages: {},
    notifications: {},
    list: [],
    object: {},
    actionsInfo: {},
    status: 'checking'
};

const messegersReducer = (state = initialInfo, action) => {

    switch (action.type) {


        case ADD_MESSENGERS: {


            let list = [...state.list] //[action.messengerId]
            let myId = action.myId

            if (!list) {
                list = []
            }

            // console.log("PRE",list?.length,action.messengers?.length)

            let found = false


            // console.log("ADD_MESSENGERS", action)

            if (action.init) {
                list = action.messengers
            } else {
                // list = [...list, ...action.messengers]
                action.messengers.forEach(messenger => {
                    found = false
                    list.forEach(oneList => {
                        if (messenger._id == oneList._id) {
                            found = true
                            // console.log('FOUND')

                        }
                    })



                    let topiclastMsg
                    let topicUdate

                    if (Array.isArray(messenger.topics)) {


                        for (let t = 0; t < messenger.topics.length; t++) {
                            const topic = messenger.topics[t];

                            // console.log("TOPIC",topic)
                            let tFound = false
                            list.forEach(oneList => {
                                if (topic._id == oneList._id) {
                                    tFound = true
                                    // console.log('tFOUND')

                                }
                            })

                            if (!tFound) {
                                list.push({ ...topic })
                            }

                            if (topic.lastMsg?.cDate > messenger.lastMsg?.cDate) {

                                topiclastMsg = JSON.parse(JSON.stringify(topic.lastMsg))
                                topiclastMsg.topicName = topic.name

                                if (messenger.lastMsg.uDate < topic.lastMsg.cDate) {

                                    topicUdate = topic.lastMsg.cDate

                                }
                            }

                        }

                    }


                    if (!found) {
                        // console.log('ADD')
                        messenger.topiclastMsg = topiclastMsg
                        if (topicUdate) {
                            messenger.uDate = topicUdate
                        }
                        createMessengerInfo(messenger, myId)
                        list.push({ ...messenger })
                    }

                });
            }

            // console.log(action.messengers)
            // console.log("AFTER", list?.length)
            // list = action.messengers
            // list.forEach((element, index) => {
            //     if (action.messengerId == element._id) {
            //         list[index]['*lastMsg'] = messages[action.messengerId][0]
            //         object[action.messengerId]['*lastMsg'] = messages[action.messengerId][0]
            //     }
            // });

            list = list.sort((a, b) => new Date(b.uDate).getTime() - new Date(a.uDate).getTime())

            // list = list.sort((a, b) => new Date(b['*lastMsg']?.cDate).getTime() - new Date(a['*lastMsg']?.cDate).getTime())
            // list.sort((a, b) => {
            //     if (!a['*lastMsg'] && !b['*lastMsg']) {
            //         return 0;
            //     }
            //     if (!a['*lastMsg']) {
            //         return 1;
            //     }
            //     if (!b['*lastMsg']) {
            //         return -1;
            //     }
            //     if (!a['*lastMsg']?.cDate && !b['*lastMsg']?.cDate) {
            //         return 0;
            //     }
            //     if (!a['*lastMsg']?.cDate) {
            //         return 1;
            //     }
            //     if (!b['*lastMsg']?.cDate) {
            //         return -1;
            //     }
            //     return new Date(b['*lastMsg'].cDate).getTime() - new Date(a['*lastMsg']?.cDate).getTime();
            // })
            let object = {}
            list.forEach(element => {
                object[element._id] = element
            });
            let status = 'gathered'
            // console.log('Tpafer1', JSON.parse(JSON.stringify(list)))
            // console.log('Tpafer1sasa', object)
            return {
                ...state,
                list: list,
                object,
                status
            }

        }

        case UPDATE_MESSENGERS: {
            let list = [...state.list]

            if (!list) {
                list = []
            }
            // console.log('UPDATE_MESSENGERS')
            // console.log('messenger action', action)
            // console.log('messenger list', list)
            action.messengers?.map((messenger) => {
                let found = false
                let cIndex
                list.map((oneList, index) => {
                    // console.log('one desk', oneList)
                    if (messenger._id == oneList._id) {
                        found = true
                        cIndex = index
                    }
                })
                if (found) {
                    // console.log('updated', messenger)
                    // console.log('last', list[cIndex])
                    list[cIndex] = messenger
                    // list[cIndex]['**name'] = messenger.name
                }
            })
            // console.log(key)
            console.log(list)

            return {
                ...state,
                list: list,
            }
        }

        
        case UPDATE_MESSENGER: {

            let list = [...state.list] //[action.messengerId]
            if (!list) {
                list = []
            }
            // console.log(action.messengerId)
            // console.log(action.messages)
            if (action.messages) {
                action.messages.forEach(message => {
                    let found = false
                    let cIndex
                    list.forEach((element, index) => {
                        if (element._id == message.action.messenger) {
                            found = true
                            cIndex = index
                        }
                    });

                    if (found) {
                        if (message.action.type == 'removeuser') {
                            list.splice(cIndex, 1)
                        }

                    }
                });
            }

            // console.log(newList)


            return {
                ...state,
                list: list,
            }
        }
        case APPEND_MESSAGES: {
            // console.log("APPEND_MESSAGES")
            // console.log(action)

            // let messages = state.messages
            let messages = { ...state.messages } //[action.messengerId]
            let list = [...state.list]
            let object = { ...state.object }
            action.messengers.forEach((oneMessenger) => {
                const messengerId = oneMessenger._id

                if (!messages[messengerId]) {
                    messages[messengerId] = []
                }

                let newList = []

                if (action.messages && action.messages[messengerId]) {
                    action.messages[messengerId].forEach(message => {
                        let found = false
                        messages[messengerId].forEach(element => {
                            if (element._id == message._id) {
                                found = true
                            }
                        });

                        if (!found) {
                            newList.push(message)
                        }
                    });
                }

                // console.log(newList)
                // console.log('messengerId', messengerId)
                messages[messengerId] = [...messages[messengerId], ...newList]
                messages[messengerId] = messages[messengerId].sort((a, b) => new Date(b.cDate).getTime() - new Date(a.cDate).getTime())



                // list.forEach((element, index) => {
                //     if (messengerId == element._id) {
                //         list[index]['*lastMsg'] = messages[messengerId][0]
                //         object[messengerId]['*lastMsg'] = messages[messengerId][0]
                //         list.forEach((item, sIndex) => {
                //             console.log('messages', messages, item._id)
                //             if (element._id == item.parent && messages[item._id]) {
                //                 console.log('ytirrr', new Date(messages[item._id][0].cDate).getTime() > new Date(list[index]['*lastMsg'].cDate).getTime())
                //                 list[index]['*lastMsg'] = messages[item._id][0]
                //                 object[item._id]['*lastMsg'] = messages[item._id][0]
                //             }
                //         })
                //     }
                // });

                // // list = list.sort((a, b) => new Date(b['*lastMsg']?.cDate).getTime() - new Date(a['*lastMsg']?.cDate).getTime())
                // list.sort((a, b) => {
                //     if (!a['*lastMsg'] && !b['*lastMsg']) {
                //         return 0;
                //     }
                //     if (!a['*lastMsg']) {
                //         return 1;
                //     }
                //     if (!b['*lastMsg']) {
                //         return -1;
                //     }
                //     if (!a['*lastMsg']?.cDate && !b['*lastMsg']?.cDate) {
                //         return 0;
                //     }
                //     if (!a['*lastMsg']?.cDate) {
                //         return 1;
                //     }
                //     if (!b['*lastMsg']?.cDate) {
                //         return -1;
                //     }
                //     return new Date(b['*lastMsg'].cDate).getTime() - new Date(a['*lastMsg']?.cDate).getTime();
                // })
            })
            action.messengers.forEach((oneMessenger) => {
                const messengerId = oneMessenger._id

                // list.forEach((element, index) => {
                //     if (messengerId == element._id) {
                //         list[index]['*lastMsg'] = messages[messengerId][0]
                //         object[messengerId]['*lastMsg'] = messages[messengerId][0]
                //         list.forEach((item, sIndex) => {
                //             if (element._id == item.parent && messages[item._id] && new Date(messages[item._id][0]?.cDate).getTime() > new Date(list[index]['*lastMsg'].cDate).getTime()) {
                //                 // console.log('element', element, item)
                //                 list[index]['*lastMsg'] = { ...messages[item._id][0], topicName: item.name }
                //                 object[item._id]['*lastMsg'] = { ...messages[item._id][0], topicName: item.name }
                //             }
                //         })
                //     }
                // });

                list = list.sort((a, b) => new Date(b.uDate).getTime() - new Date(a.uDate).getTime())
                // list.sort((a, b) => {
                //     if (!a['*lastMsg'] && !b['*lastMsg']) {
                //         return 0;
                //     }
                //     if (!a['*lastMsg']) {
                //         return 1;
                //     }
                //     if (!b['*lastMsg']) {
                //         return -1;
                //     }
                //     if (!a['*lastMsg']?.cDate && !b['*lastMsg']?.cDate) {
                //         return 0;
                //     }
                //     if (!a['*lastMsg']?.cDate) {
                //         return 1;
                //     }
                //     if (!b['*lastMsg']?.cDate) {
                //         return -1;
                //     }
                //     return new Date(b['*lastMsg'].cDate).getTime() - new Date(a['*lastMsg']?.cDate).getTime();
                // })
            })
            // console.log('messageList updated', messages)
            // console.log(object)


            // console.log(messages)
            return {
                ...state,
                messages: messages,
                list,
                object
            }

        }


        case APPEND_ONE_MESSAGE: {
            // console.log("APPEND_ONE_MESSAGE")
            // console.log(action)

            // let messages = state.messages
            let list = [...state.list]
            let object = { ...state.object }
            let message = action.messages[0]

            if (!message) {
                return {
                    ...state
                }
            }



            if (object[action.messengerId]) {

                let messages = { ...state.messages } //[action.messengerId]
                if (!messages[action.messengerId]) {
                    messages[action.messengerId] = []
                }

                let newList = []

                if (action.messages) {
                    action.messages.forEach(message => {
                        let found = false
                        messages[action.messengerId].forEach(element => {
                            if (element._id == message._id) {
                                found = true
                            }
                        });

                        if (!found) {
                            newList.push(message)
                        }
                    });
                }

                // console.log(newList)
                // console.log('action.messengerId', action.messengerId)
                messages[action.messengerId] = [...messages[action.messengerId], ...newList]
                messages[action.messengerId] = messages[action.messengerId].sort((a, b) => new Date(b.cDate).getTime() - new Date(a.cDate).getTime())



                list.forEach((element, index) => {
                    if (action.messengerId == element._id) {





                        if (object[action.messengerId] && object[action.messengerId].sequence < action.messages[0]?.sequence) {

                            // list[index]['*lastMsg'] = messages[action.messengerId][0]
                            // object[action.messengerId]['*lastMsg'] = messages[action.messengerId][0]

                            element['lastMsg'] = messages[action.messengerId][0]
                            object[action.messengerId]['lastMsg'] = messages[action.messengerId][0]

                            /// Update messenger date
                            element.uDate = messages[action.messengerId][0].cDate
                            object[action.messengerId].uDate = messages[action.messengerId][0].cDate
                        }


                        if (element.parent) {
                            list.forEach((item, sIndex) => {
                                // if (element._id == item.parent && object[item._id].sequence && object[item._id].sequence < action.messages[0]?.sequence) {
                                if (((element.parent?._id ?? element.parent) == item._id) && ((object[item._id]?.uDate ? new Date(object[item._id]?.uDate).getTime() : 0) < new Date(action.messages[0]?.cDate).getTime())) {

                                    // list[index]['*lastMsg'] = { ...messages[item._id][0], topicName: item.name }
                                    // object[item._id]['*lastMsg'] = { ...messages[item._id][0], topicName: item.name }

                                    if (messages[item._id]) {
                                        item['topiclastMsg'] = { ...messages[item._id][0], topicName: element.name }
                                        object[item._id]['topiclastMsg'] = { ...messages[item._id][0], topicName: element.name }

                                        // if (object[item._id].sequence < messages[item._id][0].sequence) {
                                        // if (item.uDate < messages[item._id][0].cDate) {
                                        item.uDate = action.messages[0].cDate
                                        object[item._id].uDate = action.messages[0].cDate
                                        // }

                                    }
                                    // }
                                }
                            })
                        }




                        if (message.systemInfo) {

                            if (message.systemInfo.type == 'topic') {

                                // console.log('message.systemInfo', message.systemInfo)
                                // console.log('element', element)
                                let topics = element.topics ?? []
                                let found = false

                                for (let t = 0; t < topics.length; t++) {
                                    const topic = topics[t];
                                    if (topic._id == message.systemInfo?.info?._id) {
                                        found = true
                                    }
                                }

                                // console.log('found', found)


                                if (!found && message.systemInfo?.info) {
                                    // console.log('PUSH')

                                    element.topics.push(message.systemInfo?.info)
                                }

                                object[element._id].topics = element.topics

                            }
                        }

                    }
                })


                // list.forEach((element, index) => {
                //     if (action.messengerId == element._id) {

                //         if (object[action.messengerId] && object[action.messengerId].sequence < action.messages[0]?.sequence) {

                //             // list[index]['*lastMsg'] = messages[action.messengerId][0]
                //             // object[action.messengerId]['*lastMsg'] = messages[action.messengerId][0]

                //             list[index]['lastMsg'] = messages[action.messengerId][0]
                //             object[action.messengerId]['lastMsg'] = messages[action.messengerId][0]

                //             /// Update messenger date
                //             list[index].uDate = messages[action.messengerId][0].cDate
                //             object[action.messengerId].uDate = messages[action.messengerId][0].cDate
                //         }
                //     }
                //     list.forEach((item, sIndex) => {
                //         // if (element._id == item.parent && object[item._id].sequence && object[item._id].sequence < action.messages[0]?.sequence) {
                //         if (element._id == item.parent && object[item._id].uDate && object[item._id].uDate < action.messages[0]?.cDate) {

                //             // list[index]['*lastMsg'] = { ...messages[item._id][0], topicName: item.name }
                //             // object[item._id]['*lastMsg'] = { ...messages[item._id][0], topicName: item.name }

                //             if (messages[item._id]) {
                //                 list[index]['topiclastMsg'] = { ...messages[item._id][0], topicName: item.name }
                //                 object[item._id]['topiclastMsg'] = { ...messages[item._id][0], topicName: item.name }

                //                 // if (object[item._id].sequence < messages[item._id][0].sequence) {
                //                 if (list[index].uDate < messages[item._id][0].cDate) {
                //                     list[index].uDate = messages[item._id][0].cDate
                //                     object[item._id].uDate = messages[item._id][0].cDate
                //                 }

                //             }
                //             // }
                //         }
                //     })
                // })

                list = list.sort((a, b) => new Date(b.uDate).getTime() - new Date(a.uDate).getTime())

                // console.log("list", list)
                // list.sort((a, b) => {
                //     if (!a['*lastMsg'] && !b['*lastMsg']) {
                //         return 0;
                //     }
                //     if (!a['*lastMsg']) {
                //         return 1;
                //     }
                //     if (!b['*lastMsg']) {
                //         return -1;
                //     }
                //     if (!a['*lastMsg']?.cDate && !b['*lastMsg']?.cDate) {
                //         return 0;
                //     }
                //     if (!a['*lastMsg']?.cDate) {
                //         return 1;
                //     }
                //     if (!b['*lastMsg']?.cDate) {
                //         return -1;
                //     }
                //     return new Date(b['*lastMsg'].cDate).getTime() - new Date(a['*lastMsg']?.cDate).getTime();
                // })


                // console.log('messageList updated', messages)
                // console.log(object)


                // console.log(messages)
                return {
                    ...state,
                    messages: messages,
                    list,
                    object
                }

            }
            break
        }


        case UPDATE_MESSAGES: {
            // console.log("UPDATE_MESSAGES")

            let messages = state.messages //[action.messengerId]
            if (!messages[action.messengerId]) {
                messages[action.messengerId] = []
            }
            // console.log(action.messengerId)
            // console.log(action.messages)
            if (action.messages) {
                action.messages.forEach(message => {
                    let found = false
                    let cIndex
                    messages[action.messengerId].forEach((element, index) => {
                        if (element._id == message.action.message) {
                            found = true
                            cIndex = index
                        }
                    });

                    if (found) {
                        if (message.action.type == 'deleted') {
                            messages[action.messengerId][cIndex].trashed = true
                        }
                        else if (message.action.type == 'deletedForMe') {
                            messages[action.messengerId].splice(cIndex, 1)
                        }
                        else if (message.action.type == 'edited') {
                            messages[action.messengerId][cIndex].text = message.modified.newMsg
                            messages[action.messengerId][cIndex].edited = true
                            // messages[action.messengerId][cIndex].text = message.text
                        }

                    }
                });
            }

            // console.log(newList)


            return {
                ...state,
                messages: messages,
            }
        }
        case REMOVE_MESSAGES: {
            let messages = state.messages //[action.messengerId]
            if (!messages[action.messengerId]) {
                messages[action.messengerId] = []
            }
            // console.log(action.messengerId)
            // console.log(action.messages)
            if (action.messages) {
                console.log(action.messages)
                action.messages.forEach(message => {
                    let found = false
                    let cIndex
                    messages[action.messengerId].forEach((element, index) => {
                        console.log(message, element)
                        if (element._id == message._id) {
                            found = true
                            cIndex = index
                        }
                    });

                    if (found) {
                        messages[action.messengerId].splice(cIndex, 1)

                    }
                });
            }

            // console.log(newList)


            return {
                ...state,
                messages: messages,
            }
        }
        case REMOVE_MESSENGER: {


            let list = [...state.list] //[action.messengerId]
            let object = state.object
            let messages = state.messages

            if (!list) {
                list = []
            }


            // list = [...list, ...action.messengers]
            let newMessages = []
            action.messengers.forEach(messenger => {
                let found = false
                let cIndex
                let messengerId = ''
                list.forEach((oneList, index) => {
                    if (messenger._id == oneList._id) {
                        found = true
                        cIndex = index
                    }
                })

                if (found) {
                    list.splice(cIndex, 1)
                    delete object[messenger._id]
                }
                messages[messenger._id].forEach((oneMessage) => {

                    if (oneMessage.messenger == messenger._id) {
                        messenger.accessLimit.forEach((access) => {
                            if (access.hub == action.myId) {
                                if (oneMessage.sequence > access.seq) {
                                    newMessages.push(oneMessage)
                                }
                            }
                        })
                    }
                    else {
                        newMessages.push(oneMessage)
                    }
                })
            });

            return {
                ...state,
                list: list,
                object: object,
                messages: newMessages
            }
        }
        case ADD_MESSAGES:
            {

                console.log("ADD_MESSAGES", action)

                // let messages = state.messages
                let messages = state.messages //[action.messengerId]
                if (!messages[action.messengerId]) {
                    messages[action.messengerId] = []
                }

                if (action.init) {
                    // console.log("INIT")
                    messages[action.messengerId] = action.messages
                } else {
                    // console.log("UPDATE")


                    let newMessages = []
                    action.messages.forEach((newMessage, index) => {
                        let exist = false
                        messages[action.messengerId].forEach(oldMessage => {
                            if (oldMessage._id == newMessage._id && newMessage._id) {
                                exist = true
                                // console.log("exist")
                                // console.log(oldMessage._id)
                            }
                        });
                        if (!exist) {
                            newMessages.push(newMessage)
                        }
                    });

                    // console.log('newMessages', newMessages)
                    messages[action.messengerId] = [...newMessages, ...messages[action.messengerId]]
                }

                let list = [...state.list]
                let object = state.object

                // console.log("action.messengerId", action.messengerId)
                list.forEach((element, index) => {

                    let msgSequence = action.tempSequence ?? action.messages[0].sequence

                    if (action.messengerId == element._id) {


                        if (object[action.messengerId] && object[action.messengerId].sequence < msgSequence) {


                            if (action.messages) {

                                element['lastMsg'] = action.messages[0]
                                object[action.messengerId]['lastMsg'] = action.messages[0]

                                element.uDate = messages[action.messengerId][0].cDate
                                object[action.messengerId].uDate = messages[action.messengerId][0].cDate
                            }

                        }

                        console.log("element.parent", element.parent)
                        if (element.parent) {

                            list.forEach((item, sIndex) => {

                                // console.log("action.messages[0]?.cDate", ((element.parent?._id ?? element.parent) == item._id), new Date(object[item._id]?.uDate).getTime(), action.messages[0]?.cDate)
                                if (((element.parent?._id ?? element.parent) == item._id) && ((object[item._id]?.uDate ? new Date(object[item._id]?.uDate).getTime() : 0) < new Date(action.messages[0]?.cDate).getTime())) {

                                    console.log("topiclastMsg", action.messages[0])

                                    if (action.messages && action.messages[0]) {
                                        item['topiclastMsg'] = { ...action.messages[0], topicName: element.name }
                                        object[item._id]['topiclastMsg'] = { ...action.messages[0], topicName: element.name }

                                        item.uDate = action.messages[0].cDate
                                        object[item._id].uDate = action.messages[0].cDate

                                        console.log("object[item._id]['topiclastMsg']", object[item._id]['topiclastMsg'])

                                    }
                                }
                            })

                        }
                    }
                });

                list = list.sort((a, b) => new Date(b.uDate).getTime() - new Date(a.uDate).getTime())


                // console.log(JSON.parse(JSON.stringify(list)))

                // list = list.sort((a, b) => new Date(b['*lastMsg']?.cDate).getTime() - new Date(a['*lastMsg']?.cDate).getTime())

                // messages[action.messengerId].splice(0, 0, action.message)
                // console.log(action.messages)

                // console.log('lisytt', list)
                // console.log(action.messengerId)

                return {
                    ...state,
                    list: [...list],
                    object,
                    // ["messages." + action.messengerId]: messages
                    // ["messages." + [action.messengerId]]: messages
                    messages: messages
                }
            }

        case CHANGE_MESSAGE:
            {
                // let messages = state.messages
                let messages = state.messages //[action.messengerId]
                if (!messages[action.messengerId]) {
                    messages[action.messengerId] = []
                }

                // console.log("CHANGE_MESSAGE")

                messages[action.messengerId].forEach(message => {
                    if (message._id === action.id && typeof action.info == "object") {
                        if (action.info) {
                            for (const [key, value] of Object.entries(action.info)) {
                                // message[key] = value
                                // console.log(key, value)
                                setObject(message, key, value)
                            }
                        }
                    }
                });

                let list = [...state.list]
                let object = state.object

                if (object[action.messengerId] && object[action.messengerId]['lastMsg'] == action.id) {
                    list.forEach((element, index) => {
                        if (action.messengerId == element._id) {
                            list[index]['lastMsg'] = messages[action.messengerId][0]
                            object[action.messengerId]['lastMsg'] = messages[action.messengerId][0]
                        }
                    });
                }

                // messages[action.messengerId].splice(0, 0, action.message)

                return {
                    ...state,
                    messages: messages,
                    list,
                    object
                }
            }

        case CHANGE_TEMP_MESSAGE: {
            let list = [...state.list]
            let object = state.object
            // let messages = state.messages

            let messages = state.messages //[action.messengerId]
            // console.log("CHANGE_TEMP_MESSAGE", action,object,messages)
            if (!messages[action.messengerId]) {
                messages[action.messengerId] = []
            }

            // console.log(messages)
            // console.log(action.tempId)


            messages[action.messengerId].forEach(message => {

                // console.log(message.tempId)

                if (message.tempId === action.tempId && typeof action.info == "object") {
                    if (action.info) {
                        for (const [key, value] of Object.entries(action.info)) {
                            message[key] = value
                        }

                        // console.log("CHANGE_TEMP_MESSAGE")
                        // console.log(action.info)
                        // console.log(message)
                    }
                }
            });


            if (object[action.messengerId] && object[action.messengerId]['lastMsg'] == action.id) {
                list.forEach((element, index) => {
                    if (action.messengerId == element._id) {
                        list[index]['lastMsg'] = messages[action.messengerId][0]
                        object[action.messengerId]['lastMsg'] = messages[action.messengerId][0]
                    }
                });
            }


            return {
                ...state,
                messages: messages,
                list,
                object
            }
        }

        // case ADD_NOTIFICATION:
        //     {
        //         let notifications = state.notifications
        //         let count = action.count ? action.count : 1
        //         // console.log('notifications[action.messengerId]', notifications, action.messengerId)
        //         notifications[action.messengerId] = notifications[action.messengerId] ? notifications[action.messengerId] + count : count

        //         return {
        //             ...state,
        //             notifications: notifications
        //         };
        //     }
        case REDUCE_NOTIFICATION:
            {
                let notifications = state.notifications

                let count = action.count ? action.count : 1
                notifications[action.messengerId] = notifications[action.messengerId] ? notifications[action.messengerId] - count : 0
                // console.log(notifications)
                return {
                    ...state,
                    notifications: notifications
                };
            }

        case SET_NOTIFICATION_COUNT:
            {
                let notifications = state.notifications
                let list = [...action.messengers]

                if (!notifications) {
                    notifications = {}
                }
                if (action.notifications) {
                    list.forEach((messenger) => {
                        notifications[messenger._id] = action.notifications[messenger._id]
                    })
                }

                return {
                    ...state,
                    notifications: notifications
                };
            }

        case CHANGE_ONE_LAST_SEEN:
            {
                // console.log("CHANGE_LAST_SEEN")
                // console.log(action.messengerId)

                let list = [...state.list]

                let notifications = state.notifications

                // console.log("state", state)
                // console.log("list", list)

                let messenger
                list.forEach(element => {
                    if (element._id == action.messengerId) {
                        messenger = element
                    }
                });
                // console.log(messenger)


                if (messenger) {
                    let currentLastSeen = messenger['lastSeen']
                    // console.log(currentLastSeen)
                    // console.log(action.messageId > currentLastSeen)

                    if (!currentLastSeen || action.messageId > currentLastSeen) {
                        messenger['lastSeen'] = action.messageId

                        let messages = state.messages[action.messengerId]

                        if (!messages) {
                            messages = []
                        }
                        // console.log(messenger['*lastSeen'])
                        // console.log('action.ownerId', action)

                        if (action.messageId) {
                            // messages = messages.filter((a) => ((a._id > action.messageId) && (a.userId !== action.ownerId)))
                            messages = messages.filter((a) => (((a.sequence > action.sequence) && (a.sender != action.ownerId))))

                        }


                        // console.log("CHANGE_LAST_SEEN")
                        // console.log(messages)
                        // console.warn(messenger['*lastSeen'])
                        // console.warn(messages[0]._id > messenger['*lastSeen'])
                        notifications[action.messengerId] = messages ? messages.length : 0


                    }
                    // messenger = action.count

                }

                return {
                    ...state,
                    list: list,
                    notifications: notifications
                };

            }
        case CHANGE_LAST_SEEN:
            {
                // console.log("CHANGE_LAST_SEEN")
                // console.log(action.messengerId)

                let list = [...state.list]

                let notifications = state.notifications

                // console.log("state", state)
                // console.log("list", list)


                action.messengers.forEach((oneMessenger) => {
                    const messengerId = oneMessenger._id
                    let messenger

                    list.forEach(element => {
                        if (element._id == messengerId) {
                            messenger = element
                        }
                    });
                    // console.log(messenger)


                    if (messenger) {
                        let currentLastSeen = messenger['lastSeen']
                        // console.log(currentLastSeen)
                        // console.log(action.messageId > currentLastSeen)

                        if (!currentLastSeen || oneMessenger.lastSeen > currentLastSeen) {
                            messenger['lastSeen'] = oneMessenger.lastSeen

                            let messages = state.messages[messengerId]

                            if (!messages) {
                                messages = []
                            }
                            // console.log(messenger['*lastSeen'])
                            // console.log('action.ownerId', action)

                            if (oneMessenger.lastSeen) {
                                // messages = messages.filter((a) => ((a._id > oneMessenger.lastSeen) && (a.userId !== action.ownerId)))
                                messages = messages.filter((a) => (((a.sequence > oneMessenger.sequence) && (a.sender != action.ownerId))))

                            }


                            // console.log("CHANGE_LAST_SEEN")
                            // console.log(messages)
                            // console.warn(messenger['*lastSeen'])
                            // console.warn(messages[0]._id > messenger['*lastSeen'])
                            notifications[messengerId] = messages ? messages.length : 0


                        }
                        // messenger = action.count

                    }
                })

                return {
                    ...state,
                    list: list,
                    notifications: notifications
                }

            }
        case UPDATE_ACTIONS: {
            let object = { ...state.object }
            let messenger = action.actionInfo.messenger
            if (!object[messenger]) {
                object[messenger] = {}
            }
            if (!object[messenger].activity) {
                object[messenger].activity = {}
            }
            if (!object[messenger].activity.isTyping) {
                object[messenger].activity.isTyping = []
            }
            let found = false
            let cIndex
            object[messenger].activity.isTyping.forEach((element, index) => {
                // console.log('notifasdsadas', element.user)
                if (element.user == action.actionInfo.user) {
                    found = true
                    cIndex = index
                }
            })
            if (found) {
                // console.log('action.actionInfo.value', action.actionInfo.value)
                // console.log(true)
                if (action.actionInfo.value == false) {
                    // console.log('actionInfo.value is false', cIndex)
                    object[messenger].activity.isTyping.splice(cIndex, 1)
                    // console.log('ipsdjfds', object[messenger].activity.isTyping)
                }
            }
            else {
                if (!found && action.actionInfo.value == true) {
                    // console.log('herrrrr', true)
                    object[messenger].activity.isTyping.push({ user: action.actionInfo.user })
                }
            }
            // console.log('object---', object)
            return {
                ...state,
                object: { ...object },
            };
        }

        case MESSAGE_SEEN:
            {

                let messages = state.messages[action.messengerId]
                let list = [...state.list]
                let object = state.object
                let myId = action.myId
                let by = action.by


                if (messages) {
                    messages.forEach(message => {
                        if (message._id == action.messageId) {
                            message.status = 2
                            setObject(message, `seen.${by}`, new Date())
                        }
                    })


                    if (object[action.messengerId] && object[action.messengerId]['lastMsg']?._id == action.messageId) {
                        list.forEach((element, index) => {
                            if (action.messengerId == element._id) {
                                list[index]['lastMsg'] = messages[0]
                                object[action.messengerId]['lastMsg'] = messages[0]
                            }

                        });
                    }
                }

                return {
                    ...state,
                    list,
                    object,
                    ["messages." + [action.messengerId]]: messages
                };
            }

        default:
            return state;
    }
}




export default messegersReducer;